enum ShareGuestType {
  NotLoggedIn,
  NewCustomer,
  ReturnedCustomer
}

export default ShareGuestType
